import { Navigate } from "react-router";
import HomeScreen from "../pages/menu/home-screen";

const menuRoutes = [
  { path: "", element: <HomeScreen /> },
  { path: "*", element: <Navigate to="/404" /> },
];

export default menuRoutes;
